/* eslint-disable */
import { pdfUpload, onApiConfigSet } from '../api.js'

import sessionStorageService from '../sessionStorage.js'


const _data = {
  pdfData: undefined,

  checkIntervalId: undefined,

  statusChangeCallback: undefined,
  contentReadyCallback: undefined,
}

function _checkIntervalCallback() {
  if (_data.pdfData.id === undefined) {
    throw new Error('PDF Data has no ID')
  }

  pdfUpload.requestFormPdfCheck({ id: _data.pdfData.id }).then(response => {
    let newStatus = response.data.status
    if (response.data.status === 'C' || response.data.status === 'E') {
      _clearInterval()
      getPdfUploadContent()
    }

    if (newStatus !== _data.pdfData.status) {
      _data.pdfData.status = newStatus
      sessionStorageService.setPdfUpload(_data.pdfData)

      if (_data.statusChangeCallback) _data.statusChangeCallback(newStatus)
    }
  }).catch((error) => {
    if (error.request.status === 410) {
      if (_data.statusChangeCallback) _data.statusChangeCallback(undefined)
      _clearInterval()
    }
  })
}

function _setupInterval() {
  if (_data.checkIntervalId === undefined) {
    _data.checkIntervalId = setInterval(_checkIntervalCallback, 8000)
  }
}

function _clearInterval() {
  if (_data.checkIntervalId) {
    clearInterval(_data.checkIntervalId)
  }
  _data.checkIntervalId = undefined
}

function _establishCallbacks() {
  if (_data.pdfData?.status === 'P' || _data.pdfData?.status === 'R') {
    _setupInterval()
  }
  else if (_data.pdfData?.status === 'C' || _data.pdfData?.status === 'E') {
    _checkIntervalCallback()
  }
}

function getPdfUploadContent() {
  pdfUpload.requestFormPdfParsedContent({ id: _data.pdfData.id }).then(response => {
    _data.pdfData.status = response.data.status
    _data.pdfData.content = response.data.content
    sessionStorageService.setPdfUpload(_data.pdfData)
    console.log(JSON.stringify(_data.pdfData))

    if (_data.contentReadyCallback) _data.contentReadyCallback(_data.pdfData)
    return _data.pdfData.content
  })
}

function uploadPdf(file, fileType, timestamp) {
  const formData = new FormData()
  formData.append('pdf_file', file)

  return pdfUpload.requestFormPdfUpload(formData, { 'Content-Type': 'application/pdf' })
    .then((response) => {
      if (response.status === 200) {
        _data.pdfData = {
          id: response.data.task_id,
          type: fileType,
          status: 'P',
          fileName: file.name,
          timestamp: timestamp,
        }
        sessionStorageService.setPdfUpload(_data.pdfData)
        _establishCallbacks()
        return _data.pdfData
      }
    }).catch((error) => {
      _data.pdfData = {
        id: undefined,
        type: fileType,
        status: 'E',
        fileName: file.name,
        timestamp: timestamp,
      }
      sessionStorageService.setPdfUpload(_data.pdfData)
      return _data.pdfData
    })
}

function exists(type) {
  getData({
    skipSetupCallbacks: true,
    skipExpiredCheck: true,
  })
  return Boolean(_data.pdfData?.type)
}

function getData(options = {}) {
  if (_data.pdfData === undefined) {
    _data.pdfData = sessionStorageService.getPdfUpload()
    if (typeof _data.pdfData?.timestamp === 'string') {
      _data.pdfData.timestamp = new Date(_data.pdfData.timestamp)
    }

    if (!options.skipExpiredCheck) {
      checkExpired()
    }
    if (!options.skipSetupCallbacks) {
      _establishCallbacks()
    }
  }
  return _data.pdfData
}

function checkExpired() {
  if (_data.pdfData) {
    let now = new Date()
    let timeDiff = (now - _data.pdfData.timestamp) / 1000
    if (timeDiff > 15 * 60) {
      clear()
    }
  }
}

function checkValidity() {
  if (_data.pdfData !== undefined && _data.pdfData.id !== undefined) {
    pdfUpload.requestFormPdfCheck({ id: _data.pdfData.id }).catch(error => {
      if (error.request.status === 410) {
        if (_data.statusChangeCallback) _data.statusChangeCallback(undefined)
        clear()
      }
    })
  }
}

function setStatusChangeCallback(callback) {
  _data.statusChangeCallback = callback
}

function setContentReadyCallback(callback) {
  _data.contentReadyCallback = callback
}

function clear() {
  _clearInterval()
  _data.pdfData = undefined
  sessionStorageService.setPdfUpload(undefined)
}

function init() {
  onApiConfigSet(() => {
    getData()
  })
}

init()


export default {
  exists,
  getData,
  uploadPdf,
  setStatusChangeCallback,
  setContentReadyCallback,
}
